import PropTypes from 'prop-types'
import React, { useEffect, useState, useRef } from 'react'
import styled from 'styled-components/macro'
import variables from 'core/styles/variables'
import { useOnMount, usePrevious } from 'core/hooks'
import CodeSentStatus from './CodeSentStatus'

const CodeInput = styled.input`
  padding: 4px;
  border: none;
  background-color: transparent;
  text-align: center;
  width: 200px;
  font-family: Roboto Mono, monospace;
  font-size: 28px;
  line-height: 1;

  color: ${variables.colorBlack60};

  margin-top: 40px;

  &:disabled {
    color: ${variables.colorBlack40};
    background-color: ${variables.colorBlack10};
  }

  /* Hide Arrows From Input Number */

  /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type='number'] {
    -moz-appearance: textfield;
  }
`
const Subtitle = styled.div`
  font-size: 14px;
  color: ${variables.colorBlack90};
  margin-top: 64px;
  text-align: center;
`
const Text = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${variables.colorBlack50};
  margin-top: ${p => p.marginTop};
  margin-bottom: ${p => p.marginBottom};
`

const Actions = styled.div`
  margin-top: 24px;
  margin-bottom: 24px;
`

const Action = styled.button`
  border: none;
  background-color: transparent;
  padding: 4px 8px;
  color: ${variables.colorBluePrimary};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-left: 16px;

  &:first-child {
    margin-left: 0;
  }

  &:hover {
    text-decoration: underline;
  }
`

const OneTimeCodeForm = props => {
  const {
    onOneTimeCode,
    sending,
    subtitle,
    onTextMe,
    onEmailMe,
    onCallMe,
    sentMessage,
    onTryAnotherWay,
    tryAnotherWayLabel
  } = props

  const [isMobile] = useState(() => 'ontouchstart' in window)

  const [code, setCode] = useState('')

  const previousCode = usePrevious(code)

  useEffect(() => {
    if (previousCode !== code && code.length === 6 && !sending) {
      onOneTimeCode(code)
    }
  }, [code, previousCode, sending, onOneTimeCode])

  const inputRef = useRef()

  useOnMount(() => {
    inputRef.current.focus()
  })

  const handleChange = (val = '') => {
    // strip non-alphanumeric characters and trim to 6 places
    setCode(val.replace(/[^0-9]/gi, '').slice(0, 6))
  }

  const handleTextMe = () => {
    setCode('')
    if (onTextMe) onTextMe()
  }

  const handleCallme = () => {
    setCode('')
    if (onCallMe) onCallMe()
  }

  const handleEmailMe = () => {
    setCode('')
    if (onEmailMe) onEmailMe()
  }

  return (
    <>
      <Subtitle>{subtitle}</Subtitle>
      <CodeInput
        ref={inputRef}
        placeholder='000000'
        value={code}
        onChange={event => handleChange(event.target.value)}
        disabled={sending}
        type={isMobile ? 'number' : 'text'}
        inputmode='numeric'
        pattern='[0-9]*'
      />
      <Text marginTop='80px'>Didn't Get the code?</Text>
      <Actions>
        {onTextMe && <Action onClick={handleTextMe}>Text me</Action>}
        {onCallMe && <Action onClick={handleCallme}>Call me</Action>}
        {onEmailMe && <Action onClick={handleEmailMe}>Email me</Action>}
      </Actions>

      <CodeSentStatus sending={sending} label={sentMessage} />

      {!!(onTryAnotherWay && tryAnotherWayLabel) && (
        <Actions>
          <Action onClick={onTryAnotherWay}>{tryAnotherWayLabel}</Action>
        </Actions>
      )}
    </>
  )
}

OneTimeCodeForm.propTypes = {
  onOneTimeCode: PropTypes.func,
  subtitle: PropTypes.string,
  sending: PropTypes.bool,
  onTextMe: PropTypes.func,
  onEmailMe: PropTypes.func,
  onCallMe: PropTypes.func,
  onTryAnotherWay: PropTypes.func,
  tryAnotherWayLabel: PropTypes.node,
  sentMessage: PropTypes.node
}

export default OneTimeCodeForm
